import React from 'react';

import { Item, PortfolioItemOverlay, PortfolioItemContent } from './styles';

interface ItemProps {
  firstTitle: string;
  secondTitle: string;
}

const PortfolioItem: React.FC<ItemProps> = ({
  firstTitle,
  secondTitle,
}: ItemProps) => {
  return (
    <Item>
      <PortfolioItemOverlay>
        <div>
          <PortfolioItemContent>
            <header>
              <h1>{firstTitle}</h1>
              <h2>{secondTitle}</h2>
            </header>
            <div>
              <p>{`${firstTitle} ${secondTitle}`}</p>
            </div>
          </PortfolioItemContent>
        </div>
      </PortfolioItemOverlay>
    </Item>
  );
};

export default PortfolioItem;
